
export class PayloadHelperProps{
}

export const InitialPayloadHelperProps: PayloadHelperProps = <PayloadHelperProps>{ 
};